/* eslint-disable react/prop-types */
import React from 'react'
import { Image, StyleSheet, Animated } from 'react-native'
import trashCan from './trashcan.png'

const TrashCan = (props) => {
  return (
        <Animated.View style={styles.container} >
            <Image style={[styles.trashcan, { transform: props.isActive ? 'scale(1.0)' : 'scale(0.9)' }]} source={trashCan} ></Image>
        </Animated.View>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 470,
    left: 550
  },
  trashcan: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 121,
    width: 98,
    transform: 'scale(0.9)'
  }
})

export const isOverlappingTrashCan = (x, y) => {
  if (!(x < styles.container.left || x > (styles.container.left + styles.trashcan.width) || y < styles.container.top || y > (styles.container.top + styles.trashcan.height))) { return true }
  return false
}

export const getTrashCanCoords = () => {
  return { x: styles.container.left, y: styles.container.top }
}

export default TrashCan
